<template>
  <div>
    <div class="md-layout md-alignment-center-space-between">
      <div class="heading md-layout md-alignment-center-space-between
            md-size-20 md-medium-20 md-small-100">
        <h1 class="md-layout-item md-size-10 md-medium-20 md-small-100">{{ title }}</h1>
        <md-button class="filter-button no-margin md-raised md-primary"
                   @click="showFilters = !showFilters">
          Filtres
        </md-button>
      </div>

      <div :class="{hideFilters:showFilters}" class="md-layout md-gutter md-layout-item md-alignment-center
          md-size-80 md-medium-size-80 md-small-size-100">
        <div class="md-layout-item">
          <md-field>
            <label>Numéro</label>
            <md-input @keyup.enter="search" v-model="filter.id"/>
          </md-field>
        </div>

        <div class="md-layout-item">
          <md-autocomplete value="" :md-options="users" @input="removeFilter"
                           @md-selected="addFilter" @md-changed="getUsers" @md-opened="getUsers">
            <label>Mail de l'acheteur</label>
            <template slot="md-autocomplete-item" slot-scope="{item}">
              {{ item.email }}
            </template>
            <template slot="md-autocomplete-empty" slot-scope="{term}">
              pas de résultat pour:{{ term }}
            </template>
          </md-autocomplete>
        </div>

        <div class="md-layout-item">
          <md-field>
            <label>État</label>
            <md-select v-model="filter.status" name="game">
              <md-option value="">Tous</md-option>
              <md-option :value="orderStatus.created">Créée</md-option>
              <md-option :value="orderStatus.ready">Prête</md-option>
              <md-option :value="orderStatus.completed">Terminée</md-option>
              <md-option :value="orderStatus.cancelled">Annulée</md-option>
            </md-select>
          </md-field>
        </div>

        <div class="md-layout-item">
          <md-field>
            <label>Paiement</label>
            <md-select v-model="filter.payment" name="game">
              <md-option value="">Tous</md-option>
              <md-option :value="paymentStatus.pending">En attente</md-option>
              <md-option :value="paymentStatus.toBeVerified">À vérifier</md-option>
              <md-option :value="paymentStatus.paid">Payée</md-option>
            </md-select>
          </md-field>
        </div>

        <md-button @click="search" class="md-icon-button md-primary">
          <md-icon>search</md-icon>
        </md-button>
      </div>
    </div>

    <md-list-item class="toolbar md-layout md-subheading">
      <div class="md-layout md-alignment-center md-xsmall-size-100">
        <span class="md-layout-item md-xsmall-size-100">No</span>
        <span class="md-layout-item md-xsmall-size-100 ">Date</span>
        <span class="md-layout-item md-xsmall-size-100 ">Acheteur</span>
        <span class="md-layout-item md-xsmall-size-60 md-small-hide">Situation</span>
        <span class="md-layout-item md-xsmall-size-15 md-small-hide">Paiement</span>
        <div class="md-layout-item md-size-10 md-small-20 md-xsmall-size-10"></div>
      </div>
    </md-list-item>

    <md-list>
      <order-item v-for="order of objects" :key="order.id" :object="order" @deleted="removeObject"/>
    </md-list>

    <pagination v-model="page" :records="total" :per-page="20" @paginate="getNext"
                :options="options"/>

    <order-form @submit="saveObject"/>
  </div>
</template>

<script>

import OrderItem from '@/components/order/OrderItem.vue';
import OrderForm from '@/components/order/OrderForm.vue';
import OrderService from '@/components/order/OrderService';
import pageMixin from '@/mixins/page-mixin';
import paginationMixin from '@/mixins/pagination-mixin';
import orderStatus from '@/components/order/order-status';
import paymentStatus from '@/components/order/payment-status';
import { sqlDateFormat } from '@/date-format';
import UserService from '@/components/user/UserService';

export default {
  name: 'OrdersPage',
  data: () => ({
    title: 'Commandes',
    service: OrderService,
    orderStatus,
    paymentStatus,
    dateFormat: sqlDateFormat,
    users: [],
    selectedUser: {},
  }),
  components: {
    OrderItem,
    OrderForm,
  },
  mixins: [pageMixin, paginationMixin],
  methods: {
    getUsers(searchTerm) {
      if (typeof searchTerm === 'string' || searchTerm === undefined) {
        this.users = UserService.searchByEmail(searchTerm);
      }
    },
    addFilter(user) {
      this.filter.user_id = user.id;
    },
    removeFilter(user) {
      if (!user) {
        this.filter.user_id = undefined;
      }
    },
  },
  async mounted() {
    try {
      await this.getFirst();
    } catch (err) {
      this.handleError(err);
    }
  },
};

</script>
